module.exports = __webpack_public_path__ + "static/images/icon-wechat-disabled.6c3e83d.png";